<template>
  <generic-modal :title="$t('emitter')" ref="generic_modal">
    <form>
      <div class="columns">
        <div class="column is-two-fifths">
          <div class="field">
            <label class="label">{{ $t("name") }}</label>
            <div class="control">
              <input
                type="text"
                class="input"
                v-model="meta.name"
                :placeholder="$t('name')"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("certifier") }}</label>
            <div class="control">
              <div class="select">
                <select class="ui dropdown" v-model="meta.certifier">
                  <option value="g4s">{{ $t("g4s") }}</option>
                  <option value="megaprint">{{ $t("megaprint") }}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("document type") }}</label>
            <div class="control">
              <div class="select">
                <select class="ui dropdown" v-model="meta.document_type">
                  <option value="fact">{{ $t("bill") }}</option>
                  <option value="receipt">{{ $t("receipt") }}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <g4s v-show="meta.certifier == 'g4s'" ref="g4s" />
      <megaprint v-show="meta.certifier == 'megaprint'" ref="megaprint" />
    </form>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
  format_currency,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import G4s from "./G4s.vue";
import Megaprint from "./Megaprint.vue";

export default {
  name: "EmitterModal",
  components: { GenericModal, G4s, Megaprint },
  props: {},
  data() {
    return {
      meta: {},
      error: "",
      emitter_uuid: undefined,
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.certifier || !v.meta.name;
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.close_modal();
    },
    show_modal(emitter_uuid) {
      let v = this;
      v.set_initial_state();
      if (emitter_uuid) {
        get("/fel/emitter", { uuid: emitter_uuid })
          .then((response) => {
            v.emitter_uuid = emitter_uuid;
            // console.log("response", response);
            v.meta.certifier = response.settings.certifier;
            v.meta.document_type = response.settings.document_type;
            v.meta.name = response.name;
            if (v.meta.certifier == "g4s") {
              v.$refs.g4s.set_data(response.settings.settings);
            } else if (v.meta.certifier == "megaprint") {
              v.$refs.megaprint.set_data(response.settings.settings);
            }
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      }
      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      let config = {};
      if (v.meta.certifier == "g4s") {
        config = v.$refs.g4s.get_data();
      } else if (v.meta.certifier == "megaprint") {
        config = v.$refs.megaprint.get_data();
      }

      if (v.emitter_uuid) {
        post("/fel/emitter", {
          uuid: v.emitter_uuid,
          name: v.meta.name,
          settings: config,
          certifier: v.meta.certifier,
          document_type: v.meta.document_type,
        })
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      } else {
        put("/fel/emitter", {
          name: v.meta.name,
          settings: config,
          certifier: v.meta.certifier,
          document_type: v.meta.document_type,
        })
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      }
    },
    set_initial_state() {
      let v = this;
      v.emitter_uuid = undefined;
      v.meta = {
        library: "",
        name: "",
        // barcode: "",
        // sale_price: "",
        // settings: {},
      };
      v.$refs.g4s.clear();
      v.$refs.megaprint.clear();
      v.error = "";
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
